import { useQuery, UseQueryOptions } from 'react-query';
import { fetchProfileIdByChatId } from './api';

type UseProfileIdByChatId = {
    chatId: string | number | null;
    eventId: number;
    options?: UseQueryOptions;
};

export const useProfileIdByChatId = ({ chatId, eventId, options }: UseProfileIdByChatId) => {
    const enabled = !!(options?.enabled && chatId) ?? !!(chatId && eventId);

    const { data, refetch } = useQuery<number, Error>(
        ['profile_id_by_chat_id', chatId],
        () => fetchProfileIdByChatId(eventId, chatId),
        {
            enabled,
            onSuccess: options?.onSuccess,
        }
    );

    return { data, refetch };
};
